var map = {
	"./cases-wrapper.css": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;



//////////////////
// WEBPACK FOOTER
// ./src/css/project ^(.*\.(css$))[^.]*$/gi
// module id = 134
// module chunks = 6